import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { uploadMedia, mediaUrl, apiError } from "@/lib/portalApi";
import { toast } from "sonner";

export default function MediaAttach({ value = [], onChange, scope = "cohort", testid }) {
  const fileRef = useRef(null);
  const [progress, setProgress] = useState(null);

  const pick = () => fileRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/") && !file.type.startsWith("video/")) {
      toast.error("Please choose a photo or video.");
      return;
    }
    setProgress(0);
    try {
      const res = await uploadMedia(file, scope, setProgress);
      onChange([...(value || []), { type: res.type, path: res.path }]);
    } catch (err) { toast.error(apiError(err)); } finally { setProgress(null); }
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-2 items-center">
        {(value || []).map((m, i) => (
          <div key={i} className="relative w-16 h-16 rounded-lg overflow-hidden border border-[#D8CEBE]">
            {m.type === "video"
              ? <video src={mediaUrl(m.path)} className="w-full h-full object-cover bg-black" />
              : <img src={mediaUrl(m.path)} alt="" className="w-full h-full object-cover" />}
            <button onClick={() => remove(i)} className="absolute top-0.5 right-0.5 bg-black/60 text-white rounded-full p-0.5"><X className="w-3 h-3" /></button>
          </div>
        ))}
        <button data-testid={`${testid}-add`} onClick={pick} type="button"
          className="w-16 h-16 rounded-lg border border-dashed border-[#C9BEB0] text-[#A9724E] flex items-center justify-center hover:bg-[#EAE3D9] transition-colors">
          {progress === null ? <ImagePlus className="w-5 h-5" strokeWidth={1.5} /> : <span className="text-xs">{progress}%</span>}
        </button>
      </div>
      <input ref={fileRef} type="file" accept="image/*,video/*" className="hidden" onChange={onFile} data-testid={`${testid}-input`} />
    </div>
  );
}
